import React from 'react';
import '../../static/styles/apiguide.scss'
import '../../static/styles/dashboard.scss'

export default class TourAPIContent extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return(
            <div className = "col-sm-12">
                <div className="page-header" id="guides-section-05">
                    <h1 className="blog-title">Tour Open API</h1>
                </div>
                {/*<Tabs>*/}
                {/*    <TabList>*/}
                {/*        <Tab>V1 API</Tab>*/}
                {/*    </TabList>*/}
                {/*    { /* tab 1 start *!/*/}
                {/*    <TabPanel>*/}
                        {/*{this.getRenderSubConponent(this.props.elementNameValue)}*/}
                        {this.props.newDiv}
                        {/*

              <h3 className="mb0 mt40">7. Delete One Tour Product API</h3>

              <div className="blog-post-meta">
                <span className="s-post">Delete the seller product with given id.</span>
                <h3 className="request-method">
                  <span className="label label-success">DELETE</span>
                </h3>
              </div>

              <div className="table-responsive">
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <td>Path</td>
                      <td>Example Endpoint</td>
                    </tr>
                    <tr>
                      <td>/v2/providers/travel_backbone_api/apis/ticket-connect/v1/marketplace/travel/tours/{'{travelProductId}'}</td>
                      <td>
                        https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-connect/v1/marketplace/travel/tours/315854700
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt10">
                <h4>Request Parameters</h4>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <th colSpan="4" className="bold">Path Segment Parameter</th>
                    </tr>
                    <tr>
                      <th>Name</th>
                      <th>Required</th>
                      <th>Type</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>travelProductId</td>
                      <td>O</td>
                      <td>String</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <h4>Response Specifications</h4>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>code</td>
                      <td>String</td>
                      <td>응답 코드</td>
                    </tr>
                    <tr>
                      <td>message</td>
                      <td>String</td>
                      <td>응답 메세지</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h3 className="panel-title">응답값 예시</h3>
                  </div>
                  <div className="panel-body">
                    <pre className="ty01">
                        {`
            {
                "code": "200",
                "message" : "success"
            }
                        `}
                    </pre>
                  </div>
                </div>
              </div>

              <h3 className="mb0 mt40">8. Create travel item inventory API</h3>

              <div className="blog-post-meta">
                <span className="s-post">Create one travel item inventory</span>
                <h3 className="request-method">
                  <span className="label label-success">POST</span>
                </h3>
              </div>

              <div className="table-responsive">
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <td>Path</td>
                    <td>Example Endpoint</td>
                  </tr>
                  <tr>
                    <td>/v1/marketplace/travel/tours/inventory</td>
                    <td>https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-connect/v1/marketplace/travel/tours/inventory
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt10">
                <h4>Request Parameters</h4>
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <th colSpan={col_number_8} className="bold">Body Parameter</th>
                  </tr>
                  <tr>
                    <th colSpan={level1}>Name</th>
                    <th>Required</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td colSpan={level1}>TravelItemInventoryDto</td>
                    <td>O</td>
                    <td>Object</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td colSpan={level2}>travelProductId</td>
                    <td>O</td>
                    <td>Long</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td colSpan={level2}>travelItemId</td>
                    <td>O</td>
                    <td>Long</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td colSpan={level2}>rateType</td>
                    <td>O</td>
                    <td>String</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td colSpan={level2}>totalStockCount</td>
                    <td>O</td>
                    <td>Int</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td colSpan={level2}>totalSoldCount</td>
                    <td>O</td>
                    <td>Int</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td colSpan={level2}>salePrice</td>
                    <td>O</td>
                    <td>Double</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td colSpan={level2}>calendarDate</td>
                    <td>O</td>
                    <td>LocalDate</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td colSpan={level2}>saleStatus</td>
                    <td>O</td>
                    <td>Int</td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <h4>Response Specifications</h4>
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td>code</td>
                    <td>String</td>
                    <td>응답 코드</td>
                  </tr>
                  <tr>
                    <td>message</td>
                    <td>String</td>
                    <td>응답 메세지</td>
                  </tr>
                  <tr>
                    <td>data</td>
                    <td>Long</td>
                    <td>travelProductId</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h3 className="panel-title">응답값 예시</h3>
                  </div>
                  <div className="panel-body">
                    <pre className="ty01">
                        {`
        {
            "code": "200",
            "message" : "success",
            "data": null
        }
                        `}
                    </pre>
                  </div>
                </div>
              </div>

              <h3 className="mb0 mt40">9. Update sale price for travel item API</h3>

              <div className="blog-post-meta">
                <span className="s-post">Update the specified sale price for travel item</span>
                <h3 className="request-method">
                  <span className="label label-success">PUT</span>
                </h3>
              </div>

              <div className="table-responsive">
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <td>Path</td>
                    <td>Example Endpoint</td>
                  </tr>
                  <tr>
                    <td> /v1/marketplace/travel/tours/inventory/travelProduct/{'{travelProductId}'}/travelItem/{'{travelItemId}'}/rateType/{'{rateType}'}/calendarDay/{'{calendarDay}'}/salePrice/{'{salePrice}'}</td>
                    <td>https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-connect/v1/marketplace/travel/tours/inventory/travelProduct/{'{travelProductId}'}/travelItem/{'{travelItemId}'}/rateType/{'{rateType}'}/calendarDay/{'{calendarDay}'}/salePrice/{'{salePrice}'}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt10">
                <h4>Request Parameters</h4>
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <th colSpan={col_number_8} className="bold">Path Segment Parameter</th>
                  </tr>
                  <tr>
                    <th colSpan={level1}>Name</th>
                    <th>Required</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td colSpan={level1}>travelProductId</td>
                    <td>O</td>
                    <td>Long</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>travelItemId</td>
                    <td>O</td>
                    <td>Long</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>calendarDay</td>
                    <td>O</td>
                    <td>LocalDate</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>salePrice</td>
                    <td>O</td>
                    <td>Double</td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <h4>Response Specifications</h4>
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td>code</td>
                    <td>String</td>
                    <td>응답 코드</td>
                  </tr>
                  <tr>
                    <td>message</td>
                    <td>String</td>
                    <td>응답 메세지</td>
                  </tr>
                  <tr>
                    <td>data</td>
                    <td>Long</td>
                    <td>travelProductId</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h3 className="panel-title">응답값 예시</h3>
                  </div>
                  <div className="panel-body">
                    <pre className="ty01">
                        {`
        {
            "code": "200",
            "message" : "success",
            "data": 315854700
        }
                        `}
                    </pre>
                  </div>
                </div>
              </div>

              <h3 className="mb0 mt40">10. Update stock quantity API</h3>

              <div className="blog-post-meta">
                <span className="s-post">Update the specified stock quantity</span>
                <h3 className="request-method">
                  <span className="label label-success">PUT</span>
                </h3>
              </div>

              <div className="table-responsive">
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <td>Path</td>
                    <td>Example Endpoint</td>
                  </tr>
                  <tr>
                    <td>/v1/marketplace/travel/tours/inventory/travelProduct/{'{travelProductId}'}/travelItem/{'{travelItemId}'}/rateType/{'{rateType}'}/calendarDay/{'{calendarDay}'}/totalStockCount/{'{totalStockCount}'}</td>
                    <td>https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-connect/v1/marketplace/travel/tours/inventory/travelProduct/{'{travelProductId}'}/travelItem/{'{travelItemId}'}/rateType/{'{rateType}'}/calendarDay/{'{calendarDay}'}/totalStockCount/{'{totalStockCount}'}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt10">
                <h4>Request Parameters</h4>
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <th colSpan={col_number_8} className="bold">Path Segment Parameter</th>
                  </tr>
                  <tr>
                    <th colSpan={level1}>Name</th>
                    <th>Required</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td colSpan={level1}>travelProductId</td>
                    <td>O</td>
                    <td>Long</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>travelItemId</td>
                    <td>O</td>
                    <td>Long</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>calendarDay</td>
                    <td>O</td>
                    <td>LocalDate</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>totalStockCount</td>
                    <td>O</td>
                    <td>Int</td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <h4>Response Specifications</h4>
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td>code</td>
                    <td>String</td>
                    <td>응답 코드</td>
                  </tr>
                  <tr>
                    <td>message</td>
                    <td>String</td>
                    <td>응답 메세지</td>
                  </tr>
                  <tr>
                    <td>data</td>
                    <td>Long</td>
                    <td>travelProductId</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h3 className="panel-title">응답값 예시</h3>
                  </div>
                  <div className="panel-body">
                    <pre className="ty01">
                        {`
        {
            "code": "200",
            "message" : "success",
            "data": 315854700
        }
                        `}
                    </pre>
                  </div>
                </div>
              </div>

              <h3 className="mb0 mt40">11. Update sold count API</h3>

              <div className="blog-post-meta">
                <span className="s-post">Update the specified sold count</span>
                <h3 className="request-method">
                  <span className="label label-success">PUT</span>
                </h3>
              </div>

              <div className="table-responsive">
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <td>Path</td>
                    <td>Example Endpoint</td>
                  </tr>
                  <tr>
                    <td>/v1/marketplace/travel/tours/inventory/travelProduct/{'{travelProductId}'}/travelItem/{'{travelItemId}'}/rateType/{'{rateType}'}/calendarDay/{'{calendarDay}'}/totalStockCount/{'{totalSoldCount}'}</td>
                    <td>https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-connect/v1/marketplace/travel/tours/inventory/travelProduct/{'{travelProductId}'}/travelItem/{'{travelItemId}'}/rateType/{'{rateType}'}/calendarDay/{'{calendarDay}'}/totalStockCount/{'{totalSoldCount}'}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt10">
                <h4>Request Parameters</h4>
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <th colSpan={col_number_8} className="bold">Path Segment Parameter</th>
                  </tr>
                  <tr>
                    <th colSpan={level1}>Name</th>
                    <th>Required</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td colSpan={level1}>travelProductId</td>
                    <td>O</td>
                    <td>Long</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>travelItemId</td>
                    <td>O</td>
                    <td>Long</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>calendarDay</td>
                    <td>O</td>
                    <td>LocalDate</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>totalSoldCount</td>
                    <td>O</td>
                    <td>Int</td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <h4>Response Specifications</h4>
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td>code</td>
                    <td>String</td>
                    <td>응답 코드</td>
                  </tr>
                  <tr>
                    <td>message</td>
                    <td>String</td>
                    <td>응답 메세지</td>
                  </tr>
                  <tr>
                    <td>data</td>
                    <td>Long</td>
                    <td>travelProductId</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h3 className="panel-title">응답값 예시</h3>
                  </div>
                  <div className="panel-body">
                    <pre className="ty01">
                        {`
        {
            "code": "200",
            "message" : "success",
            "data": 315854700
        }
                        `}
                    </pre>
                  </div>
                </div>
              </div>

              <h3 className="mb0 mt40">12. Resume sales on a given day API</h3>

              <div className="blog-post-meta">
                <span className="s-post">Resume sales on a calendar day</span>
                <h3 className="request-method">
                  <span className="label label-success">PUT</span>
                </h3>
              </div>

              <div className="table-responsive">
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <td>Path</td>
                    <td>Example Endpoint</td>
                  </tr>
                  <tr>
                    <td>/v1/marketplace/travel/tours/inventory/travelProduct/{'{travelProductId}'}/travelItem/{'{travelItemId}'}/rateType/{'{rateType}'}/calendarDay/{'{calendarDay}'}/sales/resume</td>
                    <td>https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-connect/v1/marketplace/travel/tours/inventory/travelProduct/{'{travelProductId}'}/travelItem/{'{travelItemId}'}/rateType/{'{rateType}'}/calendarDay/{'{calendarDay}'}/sales/resume</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt10">
                <h4>Request Parameters</h4>
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <th colSpan={col_number_8} className="bold">Path Segment Parameter</th>
                  </tr>
                  <tr>
                    <th colSpan={level1}>Name</th>
                    <th>Required</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td colSpan={level1}>travelProductId</td>
                    <td>O</td>
                    <td>Long</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>travelItemId</td>
                    <td>O</td>
                    <td>Long</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>calendarDay</td>
                    <td>O</td>
                    <td>LocalDate</td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <h4>Response Specifications</h4>
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td>code</td>
                    <td>String</td>
                    <td>응답 코드</td>
                  </tr>
                  <tr>
                    <td>message</td>
                    <td>String</td>
                    <td>응답 메세지</td>
                  </tr>
                  <tr>
                    <td>data</td>
                    <td>Long</td>
                    <td>travelProductId</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h3 className="panel-title">응답값 예시</h3>
                  </div>
                  <div className="panel-body">
                    <pre className="ty01">
                        {`
        {
            "code": "200",
            "message" : "success",
            "data": 315854700
        }
                        `}
                    </pre>
                  </div>
                </div>
              </div>

              <h3 className="mb0 mt40">13. Stop sales on a given day API</h3>

              <div className="blog-post-meta">
                <span className="s-post">stop sales on a calendar day</span>
                <h3 className="request-method">
                  <span className="label label-success">PUT</span>
                </h3>
              </div>

              <div className="table-responsive">
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <td>Path</td>
                    <td>Example Endpoint</td>
                  </tr>
                  <tr>
                    <td>/v1/marketplace/travel/tours/inventory/travelProduct/{'{travelProductId}'}/travelItem/{'{travelItemId}'}/rateType/{'{rateType}'}/calendarDay/{'{calendarDay}'}/sales/stop</td>
                    <td>https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-connect/v1/marketplace/travel/tours/inventory/travelProduct/504283629589889024/travelItem/191043228223418368/rateType/BASIC/calendarDay/2019-10-25/sales/stop</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt10">
                <h4>Request Parameters</h4>
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <th colSpan={col_number_8} className="bold">Path Segment Parameter</th>
                  </tr>
                  <tr>
                    <th colSpan={level1}>Name</th>
                    <th>Required</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td colSpan={level1}>travelProductId</td>
                    <td>O</td>
                    <td>Long</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>travelItemId</td>
                    <td>O</td>
                    <td>Long</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colSpan={level1}>calendarDay</td>
                    <td>O</td>
                    <td>LocalDate</td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <h4>Response Specifications</h4>
                <table className="table table-striped">
                  <tbody>
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                  <tr>
                    <td>code</td>
                    <td>String</td>
                    <td>응답 코드</td>
                  </tr>
                  <tr>
                    <td>message</td>
                    <td>String</td>
                    <td>응답 메세지</td>
                  </tr>
                  <tr>
                    <td>data</td>
                    <td>Long</td>
                    <td>travelProductId</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mt40">
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h3 className="panel-title">응답값 예시</h3>
                  </div>
                  <div className="panel-body">
                    <pre className="ty01">
                        {`
        {
            "code": "200",
            "message" : "success",
            "data": 315854700
        }
                        `}
                    </pre>
                  </div>
                </div>
              </div>
*/}


                {/*    </TabPanel>*/}
                {/*    { /* tab 1 end *!/*/}
                {/*</Tabs>*/}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TourAPIContent/TourAPIContent.jsx